/* import __COLOCATED_TEMPLATE__ from './splash.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();